<div *ngIf="hasData | async" class="wrapper">
    <canvas baseChart
        [data]="doughnutChartData"
        [options]="doughnutChartOptions"
        [plugins]="doughnutChartPlugins">
    </canvas>
</div>
